import SourceDot, { SourceAttr } from './SourceDot';

export default function TrendingCoins({ trending, onSelect, watchlistCoins, meta }) {
  if (!trending?.coins?.length) return null;

  const coins = trending.coins.slice(0, 7).map(t => t.item);

  return (
    <div className="trending-wrap">
      <div className="trending-header">
        <span className="trending-title">🔥 FELKAPOTT<SourceDot source="CoinGecko (trending)" meta={meta} /></span>
        <span className="trending-sub">A legkeresettebbek a CoinGeckón</span>
      </div>
      <div className="trending-list">
        {coins.map((item, i) => {
          const match = watchlistCoins?.find(c => c.id === item.id);
          return (
            <div
              key={item.id}
              className="trending-item"
              onClick={() => match && onSelect(match)}
              style={{ cursor: match ? 'pointer' : 'default' }}
            >
              <span className="trending-rank">{i + 1}</span>
              <img
                src={item.thumb}
                alt={item.symbol}
                className="trending-icon"
                onError={e => { e.target.style.display = 'none'; }}
              />
              <div className="trending-name">
                <span className="trending-sym">{item.symbol}</span>
                <span className="trending-full">{item.name}</span>
              </div>
              {item.market_cap_rank && (
                <span className="trending-mcap-rank">#{item.market_cap_rank}</span>
              )}
              <div className="trending-btc">
                <span className="trending-btc-price">
                  ₿ {Number(item.price_btc).toPrecision(3)}
                </span>
                {item.data?.price_change_percentage_24h?.usd != null && (
                  <span className={Number(item.data.price_change_percentage_24h.usd) >= 0 ? 'positive' : 'negative'}>
                    {Number(item.data.price_change_percentage_24h.usd) >= 0 ? '+' : ''}
                    {Number(item.data.price_change_percentage_24h.usd).toFixed(1)}%
                  </span>
                )}
              </div>
            </div>
          );
        })}
      </div>
      <SourceAttr cg />
    </div>
  );
}
